<template>
  <v-flex xs12>
    <page-toolbar>
      <summary-toolbar @change="onChange" :report-type="reportType" v-slot="slotProps">
        <kendo-button type="button" title="Export to Excel" @click="exportToExcel">
          <i class="k-icon k-i-excel"></i>
        </kendo-button>
      </summary-toolbar>
    </page-toolbar>
    <kendo-spreadsheet ref="spreadsheet" />
  </v-flex>
</template>
<script>
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import SummaryToolbar from '@/components/Report/SummaryToolbar'
import axios from 'axios'

export default {
  name: 'Summary',
  components: {
    PageToolbar,
    SummaryToolbar,
  },
  mounted() {
    const spreadsheet = this.$refs.spreadsheet.kendoWidget()
    spreadsheet.element.css('width', '100%')
    spreadsheet.resize()
  },
  methods: {
    async onChange(e) {
      const spreadsheet = this.$refs.spreadsheet.kendoWidget()
      kendo.ui.progress(spreadsheet.element, true)
      this.parameters = e
      const response = await axios.get(this.excelUrl, {responseType: 'blob'})
      const {data} = response || {}
      if (data && data.size > 0) {
        spreadsheet.fromFile(data)
      } else {
        spreadsheet
          .activeSheet()
          .range(kendo.spreadsheet.SHEETREF)
          .clear()
        spreadsheet.refresh()
      }

      kendo.ui.progress(spreadsheet.element, false)
    },
    exportToExcel() {
      location.href = this.excelUrl
    },
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    isMasterClient() {
      return this.clientId == 0
    },
    editable() {
      return this.role != 'Guest'
    },
    excelUrl() {
      const exportUrl = '/api/heroux/SummaryReport/exportToExcel'
      return `${exportUrl}?clientId=${this.clientId}&fsYear=${this.parameters.fsYear}&quarter=${
        this.parameters.quarter
      }&divisions=${this.parameters.divisions}&t=${this.tokenString}`
    },
  },
  data() {
    return {
      reportType: 3,
      parameters: null,
    }
  },
}
</script>
